import { render, staticRenderFns } from "./ManualDiscount.template.vue?vue&type=template&id=7312596f&scoped=true&"
var script = {}
import style0 from "./ManualDiscount.template.vue?vue&type=style&index=0&id=7312596f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7312596f",
  null
  
)

export default component.exports